module.exports = __webpack_public_path__ + "media/images/marisol-play-85292be2dd54580a77b99c7274225ba3.png";